/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Select } from '@neo4j-ndl/react';

const EXAMPLE_OPTIONS = [
  { label: 'Neo4j', value: 'neo4j' },
  { label: 'Needle 🪡', value: 'needle' },
  { label: 'Graph Databases', value: 'graph-database' },
  { isDisabled: true, label: 'Disabled database option', value: 'disabled' },
];

const loadOptions = (inputValue: string) => {
  return new Promise<typeof EXAMPLE_OPTIONS>((resolve) => {
    setTimeout(() => {
      const filteredOptions = EXAMPLE_OPTIONS.filter((option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase()),
      );
      resolve(filteredOptions);
    }, 1000);
  });
};

const Component = (props: React.ComponentProps<typeof Select>) => {
  return (
    <Select
      label="Label"
      helpText="Start typing to load options dynamically"
      type="async"
      selectProps={{
        cacheOptions: true,
        defaultOptions: true,
        isClearable: true,
        loadOptions,
        menuIsOpen: props.selectProps?.menuIsOpen,
        placeholder: 'Type to search...',
      }}
    />
  );
};

export default Component;
